import React, { useState, useEffect } from 'react';
import { getData } from '../helpers/ApiSettings';

const Transactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTransactions = async () => {
    try {
      setLoading(true);
      const response = await getData('/transactions?populate=*&sort[0]=createdAt:desc');
      setTransactions(response.data.data);
      console.log(response.data.data)
      setError(null);
    } catch (err) {
      setError('Erreur lors du chargement des transactions');
      console.error('Error fetching transactions:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  const formatDate = (dateString) => {
    return new Intl.DateTimeFormat('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(new Date(dateString));
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };

  const getStatusBadge = (status) => {
    const statusClasses = {
      pending: 'bg-warning',
      completed: 'bg-success',
      failed: 'bg-danger',
      refunded: 'bg-info'
    };

    const statusLabels = {
      pending: 'En attente',
      completed: 'Complété',
      failed: 'Échoué',
      refunded: 'Remboursé'
    };

    return (
      <span className={`badge ${statusClasses[status] || 'bg-secondary'}`}>
        {statusLabels[status] || status}
      </span>
    );
  };

  if (loading) {
    return (
      <div className="text-center p-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        {error}
      </div>
    );
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="h4 mb-0">Transactions</h2>
        <button 
          onClick={fetchTransactions} 
          className="btn btn-outline-primary"
        >
          Actualiser
        </button>
      </div>

      <div className="card">
        <div className="card-body">
          {transactions.length === 0 ? (
            <p className="text-center text-muted my-5">Aucune transaction pour le moment</p>
          ) : (
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>ID Transaction</th>
                    <th>Date</th>
                    <th>Commande</th>
                    <th>Montant</th>
                    <th>Statut</th>
                    <th>Mode de paiement</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.map((transaction) => (
                    transaction.order && (
                      <tr key={transaction.id}>
                        <td>{transaction.transactionId || transaction.id}</td>
                        <td>{formatDate(transaction.createdAt)}</td>
                        <td>#{transaction.order?.id}</td>
                        <td>{formatPrice(transaction.amount)}</td>
                        <td>{getStatusBadge(transaction.payment_status)}</td>
                        <td>{transaction.payment_method}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-info me-2"
                            data-bs-toggle="modal"
                            data-bs-target={`#transactionModal-${transaction.id}`}
                          >
                            Détails
                          </button>

                          {/* Modal for transaction details */}
                          <div className="modal fade" id={`transactionModal-${transaction.id}`} tabIndex="-1">
                            <div className="modal-dialog">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title">Détails de la transaction</h5>
                                  <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                                </div>
                                <div className="modal-body">
                                  <dl className="row">
                                    <dt className="col-sm-4">ID Transaction</dt>
                                    <dd className="col-sm-8">{transaction.payment_id}</dd>

                                    <dt className="col-sm-4">Date</dt>
                                    <dd className="col-sm-8">{formatDate(transaction.createdAt)}</dd>

                                    <dt className="col-sm-4">Montant</dt>
                                    <dd className="col-sm-8">{formatPrice(transaction.amount)}</dd>

                                    <dt className="col-sm-4">Statut</dt>
                                    <dd className="col-sm-8">{getStatusBadge(transaction.payment_status)}</dd>

                                    <dt className="col-sm-4">Mode de paiement</dt>
                                    <dd className="col-sm-8">{transaction.payment_method}</dd>

                                    {transaction.products && (
                                      <>
                                        <dt className="col-sm-4">Produits</dt>
                                        <dd className="col-sm-8">
                                          <ul className="list-unstyled">
                                            {transaction.products.map((product, index) => (
                                              <li key={index}>
                                                {product.name} x {product.quantity} - {formatPrice(product.price)}
                                              </li>
                                            ))}
                                          </ul>
                                        </dd>
                                      </>
                                    )}

                                    {transaction.notes && (
                                      <>
                                        <dt className="col-sm-4">Notes</dt>
                                        <dd className="col-sm-8">{transaction.notes}</dd>
                                      </>
                                    )}
                                  </dl>
                                </div>
                                <div className="modal-footer">
                                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                    Fermer
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Transactions;